<div *ngIf="!isLoading">
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="regForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">
					Dados cadastrais do cliente
				</span>
			</div>
			<div class="d-f line">
				<mat-form-field class="col-2" title="Razão social" appearance="outline">
					<mat-label>Razão social</mat-label>
					<input
						type="text"
						matInput
						placeholder="Razão social"
						formControlName="name"
						id="srs-{{ inputId }}"
					/>
					<mat-error *ngIf="regForm.get('name')?.hasError('required')">
						É necessário digitar a razão social
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 mob-va"
					title="CNPJ"
					appearance="outline"
				>
					<mat-label>CNPJ</mat-label>
					<input
						type="text"
						matInput
						mask="00.000.000/0000-00"
						placeholder="CNPJ"
						formControlName="cnpj"
						id="spj-{{ inputId }}"
						(blur)="onCnpjBlur()"
					/>
					<mat-error
						*ngIf="
							regForm.get('cnpj')?.hasError('pattern') &&
							!regForm.get('cnpj')?.hasError('required') &&
							!regForm.get('cnpj')?.hasError('minlength')
						"
					>
						Digite um CNPJ válido
					</mat-error>
					<mat-error
						*ngIf="
							regForm.get('cnpj')?.hasError('minlength') &&
							!regForm.get('cnpj')?.hasError('pattern') &&
							!regForm.get('cnpj')?.hasError('required')
						"
					>
						Já existe um cliente cadastrado com esse CNPJ
					</mat-error>
					<mat-error *ngIf="regForm.get('cnpj')?.hasError('required')">
						É necessário digitar o CNPJ
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="col-2"
					title="Nome fantasia"
					appearance="outline"
				>
					<mat-label>Nome fantasia</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome fantasia"
						formControlName="name_secondary"
						id="snf-{{ inputId }}"
					/>
					<mat-error
						*ngIf="regForm.get('name_secondary')?.hasError('required')"
					>
						É necessário digitar o nome fantasia
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 mob-va"
					title="Inscrição municipal"
					appearance="outline"
				>
					<mat-label>Inscrição municipal (opcional)</mat-label>
					<input
						type="text"
						mask="0*"
						matInput
						placeholder="Inscrição municipal (opcional)"
						formControlName="municipal_registration"
						id="sim-{{ inputId }}"
					/>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs">
				<mat-form-field
					class="col-1"
					title="Inscrição estadual"
					appearance="outline"
				>
					<mat-label>Inscrição estadual (opcional)</mat-label>
					<input
						type="text"
						mask="0*"
						matInput
						placeholder="Inscrição estadual (opcional)"
						formControlName="state_registration"
						id="sie-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs col-1 mob-va"
					title="Número da subfatura"
					appearance="outline"
				>
					<mat-label>Número da subfatura (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Número da subfatura (opcional)"
						formControlName="subinvoiceNumber"
						id="ssf-{{ inputId }}"
					/>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs">
				<mat-form-field
					class="col-1"
					title="Número da apólice"
					appearance="outline"
				>
					<mat-label>Número da apólice (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Número da apólice (opcional)"
						formControlName="insurancePolicyNumber"
						id="sap-{{ inputId }}"
					/>
				</mat-form-field>
			</div>
			<div class="d-f fd-c mt-nano">
				<p class="fs-xs lh-xs">O cliente é uma subestipulante?</p>
				<mat-radio-group
					class="mt-xs"
					formControlName="is_matriz"
					(change)="onRadioChange($event.value)"
				>
					<mat-radio-button color="primary" [value]="false">
						Sim
					</mat-radio-button>
					<mat-radio-button color="primary" class="ml-xs" [value]="true">
						Não
					</mat-radio-button>
				</mat-radio-group>
			</div>
			<div class="d-f mt-sm mb-xxxs">
				<mat-form-field
					class="col-2"
					title="CNPJ da matriz"
					appearance="outline"
					*ngIf="!showEconomicGroup"
				>
					<mat-label>CNPJ da matriz</mat-label>
					<input
						type="text"
						matInput
						placeholder="Digite para buscar CNPJ ou Razão Social da Matriz"
						[formControl]="matrizDisplayCtrl"
						[matAutocomplete]="autoMatriz"
						id="smat-{{ inputId }}"
					/>
					<mat-autocomplete
						#autoMatriz="matAutocomplete"
						[displayWith]="displayHqFn"
						(optionSelected)="onHqSelected($event)"
					>
						<ng-container
							*ngIf="filteredHeadquarters$ | async as headquartersList"
						>
							<mat-option *ngFor="let hq of headquartersList" [value]="hq">
								{{ hq.name }} ({{ hq.cnpj | mask: '00.000.000/0000-00' }})
							</mat-option>
							<mat-option
								*ngIf="
									headquartersList?.length === 0 &&
									matrizDisplayCtrl.value === null
								"
								disabled
							>
								Nenhuma matriz encontrada.
							</mat-option>
						</ng-container>
					</mat-autocomplete>
					<mat-hint align="start">
						O CNPJ da matriz da qual a subestipulante é associada
					</mat-hint>
					<mat-error *ngIf="regForm.get('matriz_id')?.hasError('required')">
						Para subestipulante o CNPJ da matriz é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="col-2"
					title="Nome do grupo econômico"
					appearance="outline"
					*ngIf="showEconomicGroup"
				>
					<mat-label>Nome do grupo econômico (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome do grupo econômico (opcional)"
						formControlName="name_economic_group"
						id="sge-{{ inputId }}"
						(focus)="showHintIdx = 1"
						(blur)="showHintIdx = -1"
					/>
					<mat-hint align="start" *ngIf="showHintIdx === 1">
						Se nenhum for definido será utilizado o nome da matriz
					</mat-hint>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="cttForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Contato do cliente</span>
			</div>
			<div class="d-f line">
				<mat-form-field
					class="col-1"
					title="Nome do responsável"
					appearance="outline"
				>
					<mat-label>Nome do responsável</mat-label>
					<input
						type="text"
						matInput
						placeholder="Nome do responsável"
						formControlName="contact_name"
						id="scr-{{ inputId }}"
						(focus)="showHintIdx = 2"
						(blur)="showHintIdx = -1"
					/>
					<mat-hint align="start" *ngIf="showHintIdx === 2">
						O nome do contato responsável dentro do cliente
					</mat-hint>
					<mat-error *ngIf="cttForm.get('contact_name')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xs line">
				<mat-form-field class="col-1" title="Telefone" appearance="outline">
					<mat-label>Telefone (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Telefone (opcional)"
						mask="(00) 00000-0000"
						formControlName="contact_phone"
						id="sph-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-2 mob-va"
					title="E-mail"
					appearance="outline"
				>
					<mat-label>E-mail</mat-label>
					<input
						type="text"
						matInput
						placeholder="E-mail"
						formControlName="contact_email"
						id="sma-{{ inputId }}"
					/>
					<mat-error
						*ngIf="
							cttForm.get('contact_email')?.hasError('email') &&
							!cttForm.get('contact_email')?.hasError('required')
						"
					>
						Digite um email válido
					</mat-error>
					<mat-error *ngIf="cttForm.get('contact_email')?.hasError('required')">
						Campo obrigatório
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="addForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Endereço do cliente</span>
			</div>
			<div class="d-f ai-c mt-xxs line">
				<mat-form-field class="mr-xs col-1" title="CEP" appearance="outline">
					<mat-label>CEP</mat-label>
					<input
						type="text"
						matInput
						placeholder="CEP"
						mask="00000-000"
						formControlName="postal_code"
						id="spc-{{ inputId }}"
						(blur)="onCepBlur()"
					/>
					<mat-error
						*ngIf="
							addForm.get('postal_code')?.hasError('pattern') &&
							!addForm.get('postal_code')?.hasError('required')
						"
					>
						Digite um CEP válido
					</mat-error>
					<mat-error *ngIf="addForm.get('postal_code')?.hasError('required')">
						É necessário digitar o CEP
					</mat-error>
				</mat-form-field>
				<a
					class="pb-xxxs mob-va"
					href="https://buscacepinter.correios.com.br/app/endereco/index.php"
					target="_blank"
				>
					Não sei o CEP
				</a>
			</div>
			<div class="d-f mt-xs line">
				<mat-form-field class="col-2" title="Endereço" appearance="outline">
					<mat-label>Endereço</mat-label>
					<input
						type="text"
						matInput
						placeholder="Endereço"
						formControlName="street"
						id="sph-{{ inputId }}"
					/>
					<mat-error *ngIf="addForm.get('street')?.hasError('required')">
						O endereço é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 mob-va"
					title="Número"
					appearance="outline"
				>
					<mat-label>Número</mat-label>
					<input
						type="text"
						matInput
						placeholder="Número"
						formControlName="number"
						id="san-{{ inputId }}"
					/>
					<mat-error *ngIf="addForm.get('number')?.hasError('required')">
						O número é obrigatório
					</mat-error>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="col-1 dyn"
					title="Complemento"
					appearance="outline"
				>
					<mat-label>Complemento (opcional)</mat-label>
					<input
						type="text"
						matInput
						placeholder="Complemento (opcional)"
						formControlName="complement"
						id="snc-{{ inputId }}"
					/>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs col-1 dyn mob-va"
					title="Bairro"
					appearance="outline"
				>
					<mat-label>Bairro</mat-label>
					<input
						type="text"
						matInput
						placeholder="Bairro"
						formControlName="neighborhood"
						id="san-{{ inputId }}"
					/>
					<mat-error *ngIf="addForm.get('neighborhood')?.hasError('required')">
						O bairro é obrigatório
					</mat-error>
				</mat-form-field>
				<mat-form-field
					class="ml-xxxs mr-xxxs col-1 dyn mob-va"
					title="Estado"
					appearance="outline"
				>
					<mat-label>Estado</mat-label>
					<mat-select formControlName="state">
						<mat-option
							*ngFor="let s of uf"
							[value]="s.uf"
							(click)="onUFChange(s.id)"
						>
							{{ s.label }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field class="col-2" title="Cidade" appearance="outline">
					<mat-label>Cidade</mat-label>
					<input
						type="text"
						matInput
						placeholder="Cidade"
						formControlName="city"
						id="sph-{{ inputId }}"
						*ngIf="!auxStateForm"
					/>
					<mat-select formControlName="city" *ngIf="auxStateForm">
						<mat-option [value]="null">Cidade</mat-option>
						<mat-option *ngFor="let city of cities" [value]="city">
							{{ city }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
	<div class="mb-xxxs br-md card">
		<div class="d-f fd-c mt-xxxs mb-nano ml-xxxs br-md" [formGroup]="addForm">
			<div class="d-f ai-c mb-xxs">
				<span class="fs-xs fw-bold lh-xs to-ellipsis">Configurar produtos</span>
			</div>
			<div class="d-f mt-xxs line">
				<mat-form-field
					class="c-p col-2"
					appearance="outline"
					(click)="openModal()"
				>
					<mat-label>Selecionar produtos</mat-label>
					<input
						type="text"
						matInput
						class="c-p"
						placeholder="Selecionar produtos"
						id="sfk-{{ inputId }}"
						[value]="productsInput"
						(focus)="ipick.focus()"
					/>
					<button matSuffix mat-icon-button aria-label="Open products dialog">
						<mat-icon>arrow_drop_down</mat-icon>
					</button>
				</mat-form-field>
				<input #ipick type="text" class="picker" />
			</div>
		</div>
	</div>
	<div class="d-f jc-fe mb-huge">
		<button
			class="margin-right-16"
			mat-stroked-button
			color="primary"
			routerLink="../"
		>
			Cancelar
		</button>
		<button
			mat-flat-button
			color="primary"
			[disabled]="shouldDisableSaveBtn()"
			(click)="onSubmit()"
		>
			{{ orgId ? 'Salvar' : 'Cadastrar cliente' }}
		</button>
	</div>
</div>
<div class="d-f jc-c ai-c w-100 mt-giant loader" *ngIf="isLoading">
	<mat-spinner diameter="20"></mat-spinner>
</div>
